export interface CalculationResult {
  totalQuantity: number;
  totalAmount: number;
  totalTax: number;
  totalPayment: number;
}

export const calculateTotals = (detailRows: MuaHangRecord[] = [], taxRows: MuaHangRecord[] = []) => {
  const totalQuantity = detailRows.reduce(
    (sum: number, row: { so_luong: string | number }) => sum + (Number(row.so_luong) || 0),
    0
  );

  const totalAmount = detailRows.reduce(
    (sum: number, row: { tien_nt: string | number }) => sum + (Number(row.tien_nt) || 0),
    0
  );

  const totalTaxFromDetail = detailRows.reduce(
    (sum: number, row: { thue_nt: string | number }) => sum + (Number(row.thue_nt) || 0),
    0
  );

  const totalTax = totalTaxFromDetail;

  const totalPayment = totalAmount + totalTax;

  return {
    totalQuantity,
    totalAmount,
    totalTax,
    totalPayment
  };
};

export const handleUpdateRowFields = (row: MuaHangRecord, field: string, newValue: MuaHangRecord) => {
  if (field === 'so_luong' || field === 'gia_nt') {
    const so_luong = Number(field === 'so_luong' ? newValue : row.so_luong) || 0;
    const gia_nt = Number(field === 'gia_nt' ? newValue : row.gia_nt) || 0;
    const tien_nt = so_luong * gia_nt;

    const thue_suat = Number(row.ma_thue_data?.thue_suat) || 0;
    const thue_nt = (tien_nt * thue_suat) / 100;

    return {
      so_luong,
      gia_nt,
      tien_nt,
      thue_nt
    };
  }

  if (field === 'ma_thue_data' || field === 'tien_nt') {
    const tien_nt = Number(field === 'tien_nt' ? newValue : row.tien_nt) || 0;
    const thue_suat = Number(field === 'ma_thue_data' ? newValue?.thue_suat : row.ma_thue_data?.thue_suat) || 0;
    const thue_nt = (tien_nt * thue_suat) / 100;
    return {
      tien_nt,
      thue_suat,
      thue_nt
    };
  }
  if (field === 'ma_vt_data') {
    return {
      dvt_data: newValue?.dvt_data || row.dvt_data,
      ma_kho_data: newValue?.ma_kho_data || row.ma_kho_data,
      tk_vt_data: newValue?.tk_khcp_data || row.tk_vt_data
    };
  }

  return {};
};
